// src/components/common/CustomDatagrid.tsx - WITH DEBUG LOGS
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useListContext, useTranslate, DatagridProps, RaRecord } from 'react-admin';
import CustomDataGridDesktop from './CustomDataGridDesktop';
import CustomDataGridMobile from './CustomDataGridMobile';
import NoDataMessage from './NoDataMessage';

interface CustomDataGridProps<RecordType extends RaRecord = any> extends DatagridProps<RecordType> {
  children: React.ReactNode;
  primarySource?: string;
  secondarySource?: string;
  detailColumns?: 2 | 3;
}

const CustomDatagrid = <RecordType extends RaRecord = any>({ 
  primarySource,
  secondarySource,
  detailColumns = 2,
  expand,
  ...props 
}: CustomDataGridProps<RecordType>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { data = [], isLoading } = useListContext();
  const translate = useTranslate();

  if (!isLoading && data.length === 0) {
    return (
      <NoDataMessage
        title={translate('common.no_data_title')}
        description={translate('common.no_data_description')}
      />
    );
  }

  if (isMobile) {
    return (
      <CustomDataGridMobile
        {...props}
        expand={expand}
        primarySource={primarySource}
        secondarySource={secondarySource}
        detailColumns={detailColumns}
      />
    );
  }

  return (
    <CustomDataGridDesktop
      {...props}
      expand={expand}
    />
  );
};

export default CustomDatagrid;